import React, { useEffect } from "react";
import AOS from "aos";
import "../Career.css";
import { Link } from "react-router-dom";

const BanerSection = () => {
  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  return (
    <div className="relative">
      <div className="bg_image_Career relative min-h-[60vh] lg:min-h-[70vh] flex items-center justify-center bg-cover bg-center bg-no-repeat">

        {/* Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-40"></div>
        {/* Content */}
        <div className="relative z-10 containers mx-auto px-4 sm:px-6 lg:px-8 text-center">
          {/* Breadcrumb */}
          <nav
            className="mb-6 text-sm md:text-base"
            data-aos="fade-down"
          >
            {/* <div className="flex items-center justify-center space-x-2 text-gray-300">
              <span className="hover:text-white transition-colors cursor-pointer">Tecz</span>
              <span>-</span>
              <span className="hover:text-white transition-colors cursor-pointer">
                IT Solutions & Technology wordpress theme
              </span>
              <span className="text-blue-400">{">"}</span>
              <span className="text-white font-semibold">Career</span>
            </div> */}
          </nav>

          {/* Heading */}
          <h1
            className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-6 tracking-tight"
            data-aos="zoom-in"
          >
            Careers
          </h1>

          {/* Accent */}
          <div className="flex justify-center mb-8" data-aos="fade-up">
            <div className="w-20 h-1 bg-gradient-to-r from-blue-400 to-blue-600 rounded-full"></div>
          </div>

          {/* Subtitle */}
          <p
            className="text-gray-200 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            At Dynamic Softlink, we believe that our people are the driving force behind our success. We are not just an IT company; we are a hub of innovation, collaboration, and creativity where ideas are nurtured and transformed into solutions that empower businesses worldwide. Based in the vibrant city of Surat, we provide a platform for passionate individuals to work on meaningful projects that make a real impact
          </p>

          {/* CTA Buttons */}
          <div
            className="flex flex-col sm:flex-row gap-4 justify-center items-center mt-10"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            <button className="bg-[#1C74BB] text-white py-[14px] px-[18px] rounded-lg font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg">
              View Open Service <span className="text-lg">➜</span>
            </button>
            <Link to={'/Contact'} className="flex items-center gap-2 border-2 border-white text-white hover:bg-white hover:text-gray-900 py-[14px] px-[18px] rounded-lg font-semibold transition-all duration-300">
              Contect HR Team
            </Link>
          </div>
        </div>

        {/* Decorative Shapes can also animate */}
        <div
          aria-hidden="true"
          className="hidden md:block absolute top-0 right-0 w-64 h-80 md:w-80 md:h-96 lg:w-96 lg:h-112 overflow-hidden opacity-90"
          data-aos="fade-left"
        >
          <div className="absolute -top-10 -right-10 w-full h-full bg-gradient-to-bl from-blue-600 to-blue-800 transform rotate-12 skew-y-6"></div>
        </div>

        <div
          aria-hidden="true"
          className="hidden lg:block absolute top-1/4 right-0 w-64 h-64 opacity-20"
          data-aos="fade-left"
          data-aos-delay="300"
        >
          <svg viewBox="0 0 200 200" className="w-full h-full">
            <path d="M20,20 Q100,80 180,20" stroke="white" strokeWidth="1" fill="none" opacity="0.3" />
            <path d="M20,40 Q100,100 180,40" stroke="white" strokeWidth="1" fill="none" opacity="0.4" />
          </svg>
        </div>

      </div>
    </div>
  );
};

export default BanerSection;
